interface IBreadCrumbItem {
  '@type': 'ListItem',
  position: number,
  name: string,
  item: string,
}

const createItemList = () => {
  const route = useRoute()
  const paths = route.path.split('/').filter(path => path)
  const previousPath = [ import.meta.env.VITE_APP_BASE_URL ]
  const itemList = [ {
    '@type': 'ListItem',
    position: 1,
    name: 'Home',
    item: previousPath.join('/'),
  } ] as Array<IBreadCrumbItem>
  paths?.forEach((path, index) => {
    previousPath.push(path)
    itemList.push({
      '@type': 'ListItem',
      position: index + 2,
      name: path,
      item: previousPath.join('/'),
    })
  })
  return itemList
}

export const getBreadCrumb = () => {
  return {
    script: [
      {
        hid: 'json-Id-breadcrumb',
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: createItemList(),
        }),
      },
    ],
  }
}